import { Modal, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MapViewer from './MapViewer';
import type { MarkerData } from './MapViewer';

export interface MapModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  markers: MarkerData[];
}

const MapModal = ({ open, onClose, title, markers }: MapModalProps) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby='map-modal-title'>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: 800,
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        <div className='bg-gray-100 px-4 py-3 border-b flex justify-between items-center'>
          <h2
            id='map-modal-title'
            className='text-lg font-semibold text-gray-800'
          >
            {title}
          </h2>
          <IconButton onClick={onClose} size='small'>
            <CloseIcon />
          </IconButton>
        </div>
        <div className='p-4'>
          {markers.length > 0 && <MapViewer markers={markers} height='h-96' />}
        </div>
      </Box>
    </Modal>
  );
};

export default MapModal;
